import React from "react";

import Hero from "./Hero";
import Stats from "./Stats";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Testimonials from "./Testimonials";
import Waitlist from "./Waitlist";
import "./homepage.scss";

const Homepage = () => (
  <div className="homepage">
    <Hero />
    <Stats />
    <Features />
    <HowItWorks />
    <Testimonials />
    <Waitlist />
  </div>
);

export default Homepage;
